import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import { Observable } from 'rxjs/Observable';
import { ConsultationUrl } from '../../shared/urls/consultation.url';

@Injectable()

export class VaccinationService {
    constructor(public baseService: BaseService) {
    }

    vaccinationSchedules(patientId: string) {
        const url = ConsultationUrl.GET_CONSULTATION_VACCINE_SCHEDULE_LASTEST;
            return this.baseService.getData(url, { patientId: patientId });
    }
}


// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/view-schedule/vaccination.service.ts